import styled from "styled-components";



interface ConnexionButtonProps {
  isLoading: boolean;
}
interface ISharedButtonProps {
  isLoading: boolean;
}

export const ConnexionButton = styled.button<ConnexionButtonProps>`
    /* background: linear-gradient(108.18deg, #1aa5c0 4.63%, #0ea1aa 122.22%); */
    box-shadow: 0px 3.35869px 3.35869px rgba(0, 0, 0, 0.25);
    border-radius: 5.87771px;
    width: 26rem;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 500;
    font-size: 20.5108px;
    line-height: 25px;
    color: #ffffff;
    box-sizing: border-box;
    margin-bottom: 20px;
  
    ${(props) => props.isLoading && `
      background: #ccc;
      cursor: not-allowed;
    `}
  `;

export const StyledSharedButton = styled.button<ISharedButtonProps>`
  /* background: linear-gradient(108.18deg, #1aa5c0 4.63%, #0ea1aa 122.22%); */
  box-shadow: 0px 3.35869px 3.35869px rgba(0, 0, 0, 0.25);
  border-radius: 5.87771px;
   
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 500;
  font-size: 15.5108px;
  line-height: 20px;
  color: #ffffff;
  box-sizing: border-box;
  margin: 10px 10px 5px 0px;

  cursor: pointer; /* Assuming it's clickable by default */

  /* &:hover {
    background: ${(props) => (props.isLoading ? '#ccc' : '#0ea1aa')};
  } */

  ${(props) =>
    props.isLoading &&
    `
    background: #ccc;
    cursor: not-allowed;
  `}
`;

export const AddPatientButton = styled.button`
  width: 346px;
  height: 50px;
  background: #20A8D3;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 20.8344px;
  line-height: 16px;
  color: #ffffff;
  cursor: pointer;
`;